import { useQuery } from "@tanstack/react-query";
import { useSelector } from "../../../../../store/store";
import { MeetingRequestService } from "../../../../../services/company-office/MeetingRequest.service";


export const useGetMyApprovals = () => {
  const user = useSelector((state) => state.user);
  const currentUserName = user?.current?.username;

  const response = useQuery({
    queryKey: ["meeting-request-my-approvals", currentUserName],
    queryFn: () =>
    MeetingRequestService.getMeetingRequests(currentUserName, ""),
    refetchOnMount:"always"
  });

  return response;
};
